import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, ArrowRight, AlertCircle, Check } from 'lucide-react';
import { api, formatApiError } from '../lib/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (pwd.length < 8) {
      setError('Mínimo 8 caracteres.');
      return;
    }
    if (pwd !== pwd2) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setStatus('loading');
    try {
      await api.post('/auth/reset-password', { token, new_password: pwd });
      setStatus('ok');
      setTimeout(() => navigate('/login', { replace: true }), 2200);
    } catch (err) {
      setStatus('err');
      setError(formatApiError(err.response?.data?.detail) || 'Token inválido o expirado.');
    }
  };

  return (
    <div className="grain min-h-screen bg-bg flex items-center justify-center px-5 py-10" data-testid="reset-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="mb-10 text-center">
          <div className="font-display text-5xl text-ink mb-2">MODARIA</div>
          <div className="text-eyebrow text-ink-muted">Nueva contraseña</div>
        </div>

        {status === 'ok' ? (
          <div data-testid="reset-success" className="bg-bg-secondary border border-line rounded-md p-8 md:p-10 text-center">
            <Check className="mx-auto mb-4 text-acid" size={32} />
            <p className="text-ink">Contraseña actualizada. Redirigiendo al login…</p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-7 bg-bg-secondary border border-line rounded-md p-8 md:p-10" data-testid="reset-form">
            {!token && (
              <div className="text-danger text-xs font-mono uppercase tracking-[0.18em] flex items-center gap-2">
                <AlertCircle size={14} /> Falta token. Pide un enlace nuevo.
              </div>
            )}
            <div>
              <label className="text-eyebrow mb-1 block flex items-center gap-2">
                <Lock size={12} /> Nueva contraseña
              </label>
              <input
                type="password"
                required
                minLength={8}
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                className="input-bare"
                data-testid="reset-pwd"
              />
            </div>
            <div>
              <label className="text-eyebrow mb-1 block flex items-center gap-2">
                <Lock size={12} /> Repetir contraseña
              </label>
              <input
                type="password"
                required
                minLength={8}
                value={pwd2}
                onChange={(e) => setPwd2(e.target.value)}
                className="input-bare"
                data-testid="reset-pwd2"
              />
            </div>
            {error && (
              <div className="text-danger text-xs font-mono uppercase tracking-[0.18em] flex items-center gap-2" data-testid="reset-error">
                <AlertCircle size={14} /> {error}
              </div>
            )}
            <button
              type="submit"
              disabled={status === 'loading' || !token}
              className="btn-acid w-full justify-center disabled:opacity-50"
              data-testid="reset-submit"
            >
              {status === 'loading' ? 'Actualizando…' : (<>Restablecer <ArrowRight size={14} /></>)}
            </button>
            <div className="text-center pt-2">
              <a href="/login" className="text-eyebrow text-ink-muted hover:text-ink">← Volver al login</a>
            </div>
          </form>
        )}
      </motion.div>
    </div>
  );
}
